export function inShadow(ele) {
  return (ele === null || ele === void 0 ? void 0 : ele.getRootNode()) !== (ele === null || ele === void 0 ? void 0 : ele.ownerDocument);
}
export function getShadowRoot(ele) {
  return inShadow(ele) ? ele === null || ele === void 0 ? void 0 : ele.getRootNode() : null;
}